import { render } from "./Generator.vue?vue&type=template&id=10e5a6ba&lang=pug"
import script from "./Generator.vue?vue&type=script&lang=js"
export * from "./Generator.vue?vue&type=script&lang=js"

import "./Generator.vue?vue&type=style&index=0&id=10e5a6ba&lang=stylus"
script.render = render

export default script